import { IOptionsWithTypes, Room } from "@eventr/common";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { cardTranslation } from "i18n/translateHelpers";
import { useUserFilter } from "../hooks/useUserFilter";
import { CardText } from "../subComponents/cardText";
import { Counter } from "../subComponents/counter";
import { UsersList } from "../subComponents/usersLists";
import { HotelUserDates } from "./hotelUserDates";
interface HotelGuestsProps {
  rooms: Room[];
  withDate?: boolean;
}

export const HotelGuests = ({ rooms, withDate = false }: HotelGuestsProps) => {
  const { filterUsers } = useUserFilter();

  const count = useMemo(() => {
    const all: IOptionsWithTypes[] = [];
    rooms?.forEach((room) => {
      all.push(...(room?.guests ?? []));
    });
    return filterUsers(all).length;
  }, [filterUsers, rooms]);
  const all = useMemo(() => {
    const all: IOptionsWithTypes[] = [];
    rooms?.forEach((room) => {
      all.push(...(room?.guests ?? []));
    });
    return all;
  }, [rooms]);
  return (
    <Stack spacing="8px">
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText variant="bodyBold">{cardTranslation("Guests")}</CardText>
        <Counter count={count} />
      </Stack>
      {/* //added a check on rooms that they exist, dates exist then so should user list but when spaming the searhc it seems to take not always have rooms.  */}
      {!withDate && <UsersList userList={all} />}
      {withDate &&
        rooms &&
        rooms.length > 0 &&
        rooms.map((room, index) => (
          <Stack key={index} spacing="8px">
            <UsersList
              subInfo={<HotelUserDates startDate={room.checkIn || ""} endDate={room.checkOut || ""} />}
              userList={room?.guests ?? []}
            />
          </Stack>
        ))}
    </Stack>
  );
};
